export default "/static/media/fall.5bc13207.css";